import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'bell-icon',
  templateUrl: './bell-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BellIconComponent {}
